import React from "react";
import { Icon } from "semantic-ui-react";
import "public/css/components.unsubscribed.scss";
import PropTypes from 'prop-types';

export default function Invitation({ status }) {
    return (
        <div className='container'>
            <div className='block'>
                {
                    status === "success" ?
                        <>
                            <Icon name="checkmark" size='massive' />
                            <h2>Your email address have been validated.</h2>
                            <p>It can take up to 24h hours to be available on your back office.</p>
                        </> :
                        <>
                            <Icon name="times" size='massive' />
                            <h2>Your email address have been rejected.</h2>
                            <p>Please contact Weezevent to have more informations.</p>
                        </>
                }
            </div>
        </div>
    );
}

Invitation.propTypes = {
    status: PropTypes.oneOf(["success", "failure"]).isRequired,
};